<template>
  <div>
    <div class="sac__font-32 semi-bold f-white margin-bottom-24">
      Opportunity Details
    </div>
    <div class="lead-detail-section">
      <div>
        <div class="grid-column ai-s jc-s gap-10">
          <img
            src="@shared/assets/img/service/info.svg"
            class="img-size-20"
          >
          <div class="sac__font-16 semi-bold">
            Lead ID:
          </div>
          <div class="sac__font-16">
            #{{ leadDetail.alertNoticeId }}
          </div>
        </div>
        <div class="grid-column ai-s jc-s gap-10 margin-top-24">
          <img
            src="@shared/assets/img/service/build.svg"
            class="img-size-20"
          >
          <div class="sac__font-16 semi-bold">
            Last Service:
          </div>
          <fragment>
            <div class="sac__font-16">
              {{ lastService.date }}
            </div>
          </fragment>
        </div>
        <div class="grid-column ai-s jc-s gap-10 margin-top-24">
          <img
            src="@shared/assets/img/service/info.svg"
            class="img-size-20"
          >
          <div class="sac__font-16 semi-bold">
            Last Assigned Tech:
          </div>
          <div class="sac__font-16">
            {{ lastService.tech }}
          </div>
        </div>
      </div>
      <div>
        <div class="grid-column ai-s jc-s gap-10">
          <img
            src="@shared/assets/img/service/calendar.svg"
            class="img-size-20"
          >
          <div class="sac__font-16 semi-bold">
            Last Occurrence:
          </div>
          <div class="sac__font-16">
            {{ alertInfo.lastOccurred }}
          </div>
        </div>
        <div class="grid-column ai-s jc-s gap-10 margin-top-24">
          <img
            src="@shared/assets/img/service/award.svg"
            class="img-size-20"
          >
          <div class="sac__font-16 semi-bold">
            Plan Type:
          </div>
          <div class="sac__font-16">
            {{ leadDetail.planName || '--' }}
          </div>
        </div>
        <div class="grid-column ai-s jc-s gap-10 margin-top-24">
          <img
            src="@shared/assets/img/service/integrate.svg"
            class="img-size-20"
          >
          <div class="sac__font-16 semi-bold">
            Service Titan:
          </div>
          <div class="sac__font-16">
            {{ leadDetail.externalStatus || '--' }}
          </div>
        </div>
      </div>
    </div>
    <div class="conversation-card">
      <img
        src="@shared/assets/img/service/flag.svg"
        class="img-size-24"
      >
      <div>
        <div class="sac__font-16 semi-bold margin-bottom-12">
          Booking an appointment? Here’s a conversation starter:
        </div>
        <div class="sac__font-16">
          <span>{{ parseCustomerScript(alertInfo.alert, 'starter') }}</span>
          <span> {{ parseCustomerScript(alertInfo.alert, 'concern') }}</span>
          <span> We recommend to schedule a service visit.</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import serviceMixin from '@shared/mixins/serviceMixin';

export default {
  name: 'LeadDetail',
  mixins: [serviceMixin],
  computed: {
    alertInfo() {
      const {
        alertId,
        alerts,
      } = this.leadDetail;
      if (!alertId && !alerts) {
        return {};
      }
      const alertFound = alerts.find((a) => a.alertId === alertId);
      return {
        alert: alertFound || {},
        lastOccurred: alertFound ? moment(alertFound.lastOccurred).format('ll') : '--',
      };
    },
    lastService() {
      const {
        pastJob,
      } = this.leadDetail;
      if (!pastJob) {
        return {
          date: '--',
          tech: '--',
        };
      }
      return {
        date: moment(pastJob.completedDate).format('ll'),
        tech: pastJob.assignedTech,
      };
    },
  },
  methods: {
    parseCustomerScript(alert, part) {
      if (!alert) {
        return '';
      }
      const {
        companyName,
      } = this.leadDetail;
      const {
        customerScript,
        boundaryValue,
        healthyValue,
      } = alert;

      if (part === 'starter') {
        let cs = 'Good {timeOfDay}. This is {Your Name} with {companyName}';
        const hourOfDay = moment().format('HH');
        let timeOfDay = 'Morning';
        if (hourOfDay >= 12) {
          timeOfDay = 'Afternoon';
        } else if (hourOfDay >= 18) {
          timeOfDay = 'Evening';
        }
        if (customerScript) {
          const sIdx = customerScript.indexOf('{#starter}');
          const eIdx = customerScript.indexOf('{/starter}');
          cs = customerScript.slice(sIdx + 10, eIdx);
        }
        cs = cs.replace('{timeOfDay}', timeOfDay);
        cs = cs.replace('{companyName}', companyName);
        return cs;
      }
      if (part === 'concern') {
        let cs = '';
        if (customerScript) {
          const sIdx = customerScript.indexOf('{#concern}');
          const eIdx = customerScript.indexOf('{/concern}');
          cs = customerScript.slice(sIdx + 10, eIdx);
        }
        const newBV = Math.round(boundaryValue);
        const newHV = Math.round(healthyValue);
        cs = cs.replace('{boundaryValue}', newBV);
        cs = cs.replace('{healthyValue}', newHV);
        cs = cs.replace('{calculatedValue}', Math.abs(newBV - newHV));
        return cs;
      }

      if (part === 'recommend') {
        let cs = '';
        if (customerScript) {
          const sIdx = customerScript.indexOf('{#recommend}');
          const eIdx = customerScript.indexOf('{/recommend}');
          cs = customerScript.slice(sIdx + 10, eIdx);
        }
        return cs;
      }

      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.lead-detail-section {
  background-color: $N90;
  border-radius: 8px;
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  color: $WHITE;
}
.conversation-card {
  color: $WHITE;
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  gap: 16px;
  background-color: $NBLUE100;
  padding: 16px;
  margin-top: 16px;
  border-radius: 8px;
}

</style>
